import { Injectable } from '@angular/core';

export interface MissingTranslationHandlerParams {
  key: string;
  translateService: any;
  interpolateParams?: any;
}

export abstract class MissingTranslationHandler {
  abstract handle(params: MissingTranslationHandlerParams): any;
}

@Injectable()
export class FakeMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    return params.key;
  }
}
